import { lazy } from 'react';
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';

const GestionUsuariosView = Loadable(lazy(() => import('views/admin/GestionUsuariosView')));
const ListarUsuariosView = Loadable(lazy(() => import('views/admin/ListarUsuariosView')));
const GestionEntidadesView = Loadable(lazy(() => import('views/admin/GestionEntidadesView')));
const GestionRolesView = Loadable(lazy(() => import('views/admin/GestionRolesView')));
const SeguimientoCargasView = Loadable(lazy(() => import('views/admin/SeguimientoCargasView')));

const AdminRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'admin',
          children: [
            
            { path: 'listar-usuarios', element: <ListarUsuariosView /> },
            { path: 'gestion-entidades', element: <GestionEntidadesView /> },
            { path: 'gestion-roles', element: <GestionRolesView /> },
            { path: 'seguimiento-cargas', element: <SeguimientoCargasView /> }
          ]
        }
      ]
    }
  ]
};

export default AdminRoutes;